module.exports = __webpack_public_path__ + "static/media/highlights-placeholder.2e27eba2.png";